import React, { Component } from 'react'
import EmailIcon from '@material-ui/icons/Email'
import SidePanel from '@root/Auth/Views/SidePanel'
import Logo from '@root/Auth/Views/SidePanel/logo.js'
import PropTypes from 'prop-types'
import Button from '@components/Button'

class NoEmailFound extends Component {
  static propTypes = {
    pageTitle: PropTypes.string,
    back: PropTypes.func
  }

  render() {
    const { pageTitle, back } = this.props
    return (
      <div className='expert-compliance'>
        <SidePanel />
        <div className='form-expert-compliance'>
          <Logo className='expert-compliance-form-logo' />
          <h1 className='form-expert-compliance__title'>{pageTitle}</h1>
          <div className='form-inner'>
            <h3 className='form-expert-compliance__title form-expert-compliance__subtitle'>
              <EmailIcon className='expert-compliance-icon' /> Contact Atheneum
            </h3>
            <div className='expert-compliance-text'>
              <div>
                If you have an account we’ve emailed you.
              </div>
              <div>
                Alternatively, please reach out to your corresponding contact or
              </div>
              <div>
                send an e-mail to <a className={'inline-link'} href={'mailto:expert.relations@atheneum-partners.com'}>expert.relations@atheneum-partners.com</a>
              </div>
            </div>
            <div className='expert-compliance-form-button-section'>
              <Button
                redWhite
                onClick={back}
              >
                Back
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NoEmailFound
